package navigation.home.customfields

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.customfields.ui.CustomFieldsEvent
import com.essntl.features.customfields.ui.CustomFieldsState
import com.essntl.features.customfields.ui.CustomFieldsViewModel
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository

class CustomFieldsScreenModel(
    areaRepository: AreaRepository,
    categoryRepository: CategoryRepository,
    supplierRepository: SupplierRepository,
    travelAgentRepository: TravelAgentRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<CustomFieldsState>(CustomFieldsState()) {

    val vm =
        CustomFieldsViewModel(
            areaRepository = areaRepository,
            categoryRepository = categoryRepository,
            supplierRepository = supplierRepository,
            travelAgentRepository = travelAgentRepository,
            loadingManager = loadingManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: CustomFieldsEvent) = vm.onEvent(event)
}